import React, { useEffect, useState } from "react";
import FilterBar from "../Components/FilterBar";
import ReportTable from "../Components/ReportTable";
import Pagination from "../Components/Pagination";
import api from "../../../../api/axios";
import * as XLSX from "xlsx";
import { useLocation } from "react-router-dom";

export default function BaseReportPage({
  apiEndpoint,
  columns,
  downloadEndpoint,
  title,
  emptyMessage,
  customTable,
  defaultFilters = {},
}) {
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState({ page: 1, limit: 25, total: 0 });
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const location = useLocation();
  const isConsolidated = location.state?.isConsolidated || false;

  const [filters, setFilters] = useState({
    type: "daily",
    date: "",
    from_date: "",
    to_date: "",
    month: "",
    year: "",
    outlet: "",
    department: "",
    employee_id: "",
    page: 1,
    limit: 25,
    ...defaultFilters,
  });

  // useEffect(() => {
  //   if (isConsolidated) {
  //     const today = new Date().toISOString().split("T")[0];

  //     setFilters((prev) => ({
  //       ...prev,
  //       type: "range",
  //       from_date: prev.from_date || today,
  //       to_date: prev.to_date || today,
  //     }));
  //   }
  // }, [isConsolidated]);

  const [masters, setMasters] = useState({
    outlets: [],
    departments: [],
    employees: [],
  });

  useEffect(() => {
    api
      .get(`hrms/attendance/outlets`)
      .then((r) => setMasters((m) => ({ ...m, outlets: r.data })));

    api
      .get(`hrms/attendance/departments`)
      .then((r) => setMasters((m) => ({ ...m, departments: r.data })));

    api
      .get("hrms/employees")
      .then((r) => setMasters((m) => ({ ...m, employees: r.data.data })));
  }, [apiEndpoint]);

  const load = async (page = 1, limit = pageInfo.limit) => {
    setLoading(true);
    try {
      const res = await api.get(apiEndpoint, {
        params: {
          ...filters,
          page: isConsolidated ? 1 : page,
          limit: isConsolidated ? 100000 : limit,
        },
      });

      const payload = res.data || {};
      const rows = payload.data || [];
      setData(rows);
      setPageInfo({
        page: isConsolidated ? 1 : payload.page || page,
        limit: isConsolidated ? rows.length : payload.limit || limit,
        total: payload.total,
      });
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const onApply = () => load(1, pageInfo.limit);
  const onPageChange = (page) => load(page, pageInfo.limit);

  const handleDownload = async () => {
    setDownloading(true);

    try {
      const finalParams = {
        ...filters,
        ...(isConsolidated ? { only: "consolidated" } : {}),
      };
      const res = await api.get(downloadEndpoint, {
        params: finalParams,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.download = title.replace(/\s+/g, "_") + ".xlsx";
      link.click();
      link.remove();
    } catch (err) {
      console.error("Download failed:", err);
    }
    setDownloading(false);
  };

  const uiData = data;

  return (
    <div className="container mt-4">
      <h3>{title}</h3>
      <p className="text-muted">
        Select filters, then Generate to load the report.
      </p>

      <FilterBar
        filters={filters}
        masters={masters}
        setFilter={setFilters}
        onApply={onApply}
        onDownload={handleDownload}
        loading={loading}
        downloading={downloading}
        data={data}
        isConsolidated={isConsolidated}
      />

      {loading ? (
        <div className="text-center py-4">Loading...</div>
      ) : (
        <>
          {customTable ? (
            customTable(uiData)
          ) : (
            <ReportTable
              columns={columns}
              data={uiData}
              emptyMessage={emptyMessage}
              page={pageInfo.page}
              limit={pageInfo.limit}
            />
          )}

          <Pagination
            page={pageInfo.page}
            limit={pageInfo.limit}
            total={pageInfo.total}
            onPageChange={onPageChange}
          />
        </>
      )}
    </div>
  );
}
